"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var PhDScience_exports = {};
__export(PhDScience_exports, {
  default: () => PhDScience_default
});
module.exports = __toCommonJS(PhDScience_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 200 200",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M0 8C0 3.58173 3.58172 0 8 0H192C196.418 0 200 3.58172 200 8V192C200 196.418 196.418 200 192 200H8C3.58173 200 0 196.418 0 192V8Z",
      fill: "#845AA2"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M51.3372 97.7489V88.0462C51.3372 87.6818 51.1985 87.3988 50.9255 87.1887C50.6481 86.9829 50.3534 86.8757 50.0371 86.8757C49.7207 86.8757 49.387 86.9743 49.0317 87.1673C48.6763 87.3602 48.4986 87.7204 48.4986 88.2392V97.7489H40.659V70H48.4986V80.9504C49.023 80.5345 49.673 80.1958 50.4488 79.9385C51.2245 79.677 52.0436 79.5483 52.9103 79.5483C54.8821 79.5483 56.4422 80.1186 57.5993 81.2634C58.7564 82.4081 59.3328 83.9516 59.3328 85.9025V97.7489H51.3372Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M38.4705 79.1453C38.4705 80.4445 38.2364 81.6407 37.7727 82.7383C37.3047 83.8359 36.6416 84.7792 35.7836 85.5724C34.9212 86.3656 33.9028 86.9915 32.724 87.4546C31.5452 87.9176 30.2538 88.1449 28.854 88.1449H25.6168V97.749H16.7371V70.1458H28.8497C30.2495 70.1458 31.5409 70.3773 32.7197 70.8404C33.9028 71.3034 34.9212 71.9294 35.7792 72.7226C36.6373 73.5158 37.3047 74.4591 37.7684 75.5567C38.2364 76.65 38.4705 77.8462 38.4705 79.1453ZM29.7684 79.1453C29.7684 78.4808 29.5344 77.9834 29.0707 77.6533C28.6027 77.3231 28.1216 77.1559 27.6276 77.1559H25.6168V81.1348H27.6276C28.1216 81.1348 28.6027 80.9675 29.0707 80.6374C29.5344 80.303 29.7684 79.8056 29.7684 79.1453Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M85.8332 89.5941C86.609 87.9048 86.9947 86.0226 86.9947 83.9474C86.9947 81.8679 86.609 79.9857 85.8332 78.3007C85.0575 76.6157 84.0088 75.1665 82.6826 73.9531C81.3565 72.7398 79.7878 71.8051 77.9806 71.1405C76.1735 70.476 74.2363 70.1458 72.1648 70.1458H61.8853V97.749H72.1648C74.232 97.749 76.1735 97.4188 77.9806 96.7543C79.7878 96.0897 81.3565 95.155 82.6826 93.9416C84.0131 92.7325 85.0618 91.2834 85.8332 89.5941ZM77.1572 81.4821C77.5082 82.2024 77.6816 83.0256 77.6816 83.9474C77.6816 84.8692 77.5039 85.6967 77.1572 86.4342C76.8062 87.1716 76.3425 87.7847 75.7574 88.2735C75.1767 88.7623 74.505 89.1353 73.7466 89.3968C72.9882 89.6584 72.1865 89.787 71.3414 89.787H70.7737V78.1078H71.3414C72.1865 78.1078 72.9882 78.2364 73.7466 78.4979C74.505 78.7552 75.1724 79.1368 75.7574 79.6427C76.3425 80.1486 76.8062 80.7617 77.1572 81.4821Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M37.2484 120.336C37.2484 123.324 36.308 125.682 34.4315 127.41C32.555 129.138 29.7381 130 25.9852 130C24.0133 130 22.2149 129.781 20.5941 129.348C18.9733 128.915 17.5302 128.203 16.2647 127.217L16.0004 118.861C17.3785 120.078 18.8303 120.966 20.3557 121.515C21.8812 122.068 23.463 122.342 25.1054 122.342C26.0458 122.342 26.7175 122.256 27.1292 122.081C27.5409 121.905 27.7446 121.63 27.7446 121.253C27.7446 121.022 27.7056 120.833 27.6363 120.687C27.5626 120.541 27.3849 120.396 27.1076 120.25C26.8302 120.104 26.4272 119.933 25.8985 119.727C25.3698 119.525 24.6677 119.264 23.788 118.942C21.3828 118.042 19.5626 116.794 18.3319 115.199C17.1011 113.604 16.4857 111.846 16.4857 109.934C16.4857 108.571 16.7371 107.314 17.2355 106.17C17.7338 105.025 18.4446 104.043 19.3546 103.233C20.269 102.422 21.3741 101.788 22.6699 101.338C23.9657 100.887 25.4088 100.664 26.9949 100.664C28.0523 100.664 28.9754 100.716 29.7685 100.819C30.5615 100.922 31.2549 101.046 31.8573 101.188C32.4597 101.333 32.984 101.513 33.4391 101.732C33.8941 101.951 34.2971 102.161 34.6482 102.362L34.3838 110.11C33.5604 109.587 32.6027 109.154 31.5019 108.802C30.4012 108.455 29.3091 108.279 28.2257 108.279C27.2289 108.279 26.5702 108.361 26.2452 108.519C25.9245 108.678 25.7598 108.931 25.7598 109.282C25.7598 109.458 25.7945 109.608 25.8681 109.741C25.9418 109.87 26.1152 110.011 26.3969 110.153C26.6742 110.299 27.0772 110.474 27.606 110.676C28.1347 110.877 28.8671 111.126 29.8075 111.418C30.8345 111.765 31.801 112.237 32.711 112.832C33.6211 113.428 34.4098 114.119 35.0859 114.899C35.7619 115.684 36.2863 116.537 36.6677 117.467C37.0577 118.393 37.2484 119.35 37.2484 120.336Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M59.2635 109.192C60.1865 109.484 61.0316 109.874 61.7943 110.367L62.0543 102.259C61.2049 101.766 60.1042 101.376 58.7564 101.085C57.4086 100.797 55.9395 100.652 54.3577 100.652C52.4509 100.652 50.5744 100.969 48.7283 101.608C46.8821 102.247 45.231 103.181 43.7792 104.416C42.3275 105.651 41.153 107.181 40.2603 109.008C39.3632 110.839 38.9169 112.94 38.9169 115.319C38.9169 117.729 39.3632 119.847 40.2603 121.673C41.153 123.5 42.3275 125.03 43.7792 126.265C45.231 127.5 46.8821 128.431 48.7283 129.052C50.5744 129.674 52.4509 129.987 54.3577 129.987C55.9395 129.987 57.4 129.841 58.7348 129.55C60.0695 129.258 61.0706 128.868 61.7467 128.375L62.011 120.28C61.335 120.773 60.4986 121.163 59.5018 121.455C58.5051 121.746 57.3306 121.892 55.9829 121.892C54.7218 121.892 53.621 121.703 52.6849 121.326C51.7445 120.949 50.9601 120.451 50.3318 119.825C49.699 119.204 49.231 118.501 48.9233 117.716C48.6113 116.936 48.4596 116.138 48.4596 115.324C48.4596 114.513 48.6026 113.716 48.8973 112.931C49.192 112.151 49.634 111.448 50.2191 110.822C50.8085 110.2 51.5409 109.698 52.4206 109.321C53.3003 108.944 54.3274 108.755 55.5018 108.755C57.088 108.755 58.3404 108.901 59.2635 109.192Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { d: "M65.5343 129.215V101.449H74.9037V129.215H65.5343Z", fill: "white" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M79.0813 101.449V129.215H97.6035V121.772H88.4551V119.161H94.9643V111.499H88.4551V108.888H96.7237V101.449H79.0813Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M122.37 129.215L113.794 119.77C113.031 118.959 112.303 118.123 111.614 117.266C110.925 116.413 110.301 115.619 109.746 114.895L109.66 114.938C109.72 115.632 109.764 116.417 109.79 117.287C109.82 118.158 109.833 118.955 109.833 119.68V129.211H100.464V101.449H108.559L115.467 109.111C115.996 109.69 116.568 110.35 117.183 111.092C117.798 111.834 118.31 112.494 118.722 113.073L118.808 113.03C118.748 112.421 118.704 111.812 118.678 111.203C118.648 110.594 118.635 109.926 118.635 109.201V101.449H128.004V129.215H122.37Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M151.644 109.192C152.572 109.484 153.413 109.874 154.175 110.367L154.435 102.259C153.586 101.766 152.485 101.376 151.137 101.085C149.79 100.797 148.325 100.652 146.739 100.652C144.832 100.652 142.955 100.969 141.109 101.608C139.263 102.247 137.612 103.181 136.16 104.416C134.708 105.651 133.534 107.181 132.641 109.008C131.744 110.839 131.298 112.94 131.298 115.319C131.298 117.729 131.749 119.847 132.641 121.673C133.534 123.5 134.708 125.03 136.16 126.265C137.612 127.5 139.263 128.431 141.109 129.052C142.955 129.674 144.832 129.987 146.739 129.987C148.321 129.987 149.781 129.841 151.116 129.55C152.451 129.258 153.452 128.868 154.128 128.375L154.392 120.28C153.716 120.773 152.88 121.163 151.883 121.455C150.886 121.746 149.712 121.892 148.364 121.892C147.103 121.892 146.002 121.703 145.066 121.326C144.126 120.949 143.341 120.451 142.713 119.825C142.08 119.204 141.612 118.501 141.304 117.716C140.992 116.936 140.841 116.138 140.841 115.324C140.841 114.513 140.984 113.716 141.278 112.931C141.573 112.151 142.011 111.448 142.6 110.822C143.189 110.2 143.922 109.698 144.802 109.321C145.681 108.944 146.708 108.755 147.883 108.755C149.465 108.755 150.721 108.901 151.644 109.192Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M157.694 129.215V101.449H175.337V108.888H167.064V111.499H173.577V119.161H167.064V121.772H176.216V129.215H157.694Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M179.571 106.414H180.299V105.166H180.641C181.044 105.166 181.235 105.321 181.291 105.659C181.311 105.732 181.328 105.801 181.345 105.867C181.411 106.125 181.462 106.325 181.538 106.414H182.323C182.245 106.298 182.188 106.11 182.093 105.638C181.998 105.222 181.824 104.995 181.521 104.883V104.845C181.902 104.733 182.171 104.467 182.171 104.129C182.171 103.824 182.037 103.58 181.863 103.447C181.634 103.314 181.369 103.22 180.775 103.22C180.255 103.22 179.857 103.258 179.571 103.314V106.414ZM180.654 104.656H180.307V103.769C180.385 103.751 180.52 103.73 180.71 103.73C181.17 103.73 181.378 103.919 181.378 104.202C181.378 104.523 181.057 104.656 180.654 104.656Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M180.788 107.927C182.604 107.927 184 106.547 184 104.789C184 103.07 182.604 101.689 180.788 101.689C178.994 101.689 177.56 103.07 177.56 104.789C177.56 106.547 178.994 107.927 180.788 107.927ZM180.81 107.267C179.397 107.267 178.366 106.17 178.366 104.789C178.366 103.43 179.397 102.315 180.788 102.315C182.184 102.315 183.198 103.43 183.198 104.81C183.198 106.17 182.184 107.267 180.81 107.267Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8 1H192V-1H8V1ZM199 8V192H201V8H199ZM192 199H8V201H192V199ZM1 192V8H-1V192H1ZM8 199C4.13401 199 1 195.866 1 192H-1C-1 196.971 3.02944 201 8 201V199ZM199 192C199 195.866 195.866 199 192 199V201C196.971 201 201 196.971 201 192H199ZM192 1C195.866 1 199 4.13401 199 8H201C201 3.02944 196.971 -1 192 -1V1ZM8 -1C3.02944 -1 -1 3.02944 -1 8H1C1 4.13401 4.13401 1 8 1V-1Z",
      fill: "#706C5C"
    }
  )
);
const SvgPhDScience = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var PhDScience_default = SvgPhDScience;
